import {useTranslation} from "react-i18next";
import {Stack, Switch, Textarea, TextInput} from "@mantine/core";
import {useTagCategoryFormContext} from "./useTagCategoryForm";
import {TagCategoryFormProps} from "./TagCategoryForm";

export type TagCategoryFormFieldProps = Pick<TagCategoryFormProps, 'options'> & {}

export const TagCategoryFormFields = (props: TagCategoryFormFieldProps) => {
  const {
    options,
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useTagCategoryFormContext();

  return (
    <Stack spacing="xs">
      <TextInput
        size="xs"
        label={t("common.entity.tagcategory.form.field.label", "Label")}
        placeholder={t<string>("common.entity.tagcategory.form.field.label.placeholder", "Label")}
        withAsterisk
        required
        {...form.getInputProps('label')}/>

      <Textarea
        size="xs"
        label={t("common.entity.tagcategory.form.field.desc", "Description")}
        placeholder={t<string>("common.entity.tagcategory.form.field.desc.placeholder", "Description")}
        minRows={4}
        autosize
        {...form.getInputProps('description')} />

      <Switch
        size="xs"
        mt="md"
        label={t("common.entity.tagcategory.form.field.donotuse", "Do Not Use")}
        {...form.getInputProps("doNotUse", {type: 'checkbox'})} />

    </Stack>
  )
}
